module.exports = __webpack_public_path__ + "media/images/icons/banda_invitada_black-4dc9fe12d01561e4a1e613556b43c1c8.svg";